'use client';

import React from 'react';

import { CategoriesSwiper } from '@/components';
import { useCategories } from '@/hooks';
import { routes } from '@/statics';

const RootCategories: React.FC = () => {
  const { data: categoriesData } = useCategories();
  const rootCategories = categoriesData?.filter(
    (item) => item.parent_code === null
  );

  return (
    <>
      {rootCategories && (
        <CategoriesSwiper
          categories={rootCategories}
          hrefCreator={(categoryCode: number) =>
            routes.category.href(categoryCode)
          }
        />
      )}
    </>
  );
};
export default RootCategories;
